/** The Claude model a person picked for drawing takeoffs. Opus 5.5 is the default. */
export const TAKEOFF_MODELS = [
  { id: 'claude-opus-5-5', label: 'Claude Opus 5.5' },
  { id: 'claude-fable-5-1', label: 'Claude Fable 5.1' },
  { id: 'claude-sonnet-5-5', label: 'Claude Sonnet 5.5' },
  { id: 'claude-haiku-4-5', label: 'Claude Haiku 4.5' },
] as const;
export type TakeoffModelId = typeof TAKEOFF_MODELS[number]['id'];
export const DEFAULT_TAKEOFF_MODEL: TakeoffModelId = 'claude-opus-5-5';
const STORAGE_KEY = 'quantis-ai:takeoff-model';
export function takeoffModelId(value: unknown): TakeoffModelId {
  return TAKEOFF_MODELS.find(model => model.id === value)?.id ?? DEFAULT_TAKEOFF_MODEL;
}
export function readStoredTakeoffModel(): TakeoffModelId {
  try { return takeoffModelId(window.localStorage.getItem(STORAGE_KEY)); } catch { return DEFAULT_TAKEOFF_MODEL; }
}
export function storeTakeoffModel(model: TakeoffModelId) {
  try { window.localStorage.setItem(STORAGE_KEY, model); } catch { /* The choice simply lasts for this page. */ }
}
